export default __webpack_public_path__ + "static/media/about.2f2f99a1.png";